var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"mail"),React.createElement("path",{"d":"M320,96H88a40,40,0,0,0-40,40V376a40,40,0,0,0,40,40H422.73a40,40,0,0,0,40-40V239","style":{"fill":"none","stroke":"#E85A4F","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("polyline",{"points":"112 160 256 272 343 206.33","style":{"fill":"none","stroke":"#E85A4F","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2}),React.createElement("circle",{"cx":"431.95","cy":"128.05","r":"47.95","key":3}),React.createElement("path",{"d":"M432,192a63.95,63.95,0,1,1,63.95-63.95A64,64,0,0,1,432,192Zm0-95.9a32,32,0,1,0,31.95,32A32,32,0,0,0,432,96.1Z","key":4})]);
}

MailInline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = MailInline;

MailInline.default = MailInline;
